export default __webpack_public_path__ + "assets/credit-card-component.be3d389b.svg";